<template>
  <div class="box10">
    <pageTitle
      title="百万粉丝大V真实分享实战运营之道"
      text="用实力诠释、用事实证明，抽丝剥茧带你揭秘运营底层逻辑"
      titleColor="#1A0400"
      titColor="#665552"
    />
    <div class="subTitle"></div>
    <div class="teacher-box">
      <div
        class="teacher"
        v-for="(item, index) in teacherList"
        :key="index"
        :style="
          `backgroundImage: url(` +
          require(`../../../assets/coursePage/newMedia/box8/${index + 1}.png`) +
          `)`
        "
        @click="changeCur(index)"
      >
        <div class="tName">{{ item.name }}</div>
        <p v-html="item.teachInfo"></p>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ teacherList[this.cur].name }}</div>

          <div class="close" @click="show = false"></div>
        </div>

        <p>
          {{ teacherList[this.cur].teachInfo }}
        </p>
        <div class="tag">项目业绩</div>
        <p>
          {{ teacherList[this.cur].performanceInfo }}
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      cur: 0,
      show: false,
      teacherList: [
        {
          name: "张老师",
          teachInfo:
            "5年短视频直播实战经验，曾担任多家企业运营总监、操盘手。擅长流量整体规划操盘、0-1爆款内容孵化、内容制作以及直播引流变现。授课风格幽默严谨，擅长用案例启发思考。",
          performanceInfo: "孵化的蓝V账号曾在地产赛道取得第1名成绩。",
        },
        {
          name: "短视频运营婧姐",
          teachInfo:
            "运营过抖音、火山、西瓜、微视等多个上百万粉丝大号，通过短视频营销策略帮助企业快速打开市场。两周时间在抖音平台吸引精准粉丝10w+。",
          performanceInfo:
            "服务1000+学员，擅长短视频直播变现，曾帮助多位学员实现1个月涨粉20w+,变现100w+。",
        },
        {
          name: "船长老师",
          teachInfo:
            "运营十余微信公众平台，全网累计粉丝超百万，为企业带来千万收益，为上百企业搭建新媒体运营渠道。",
          performanceInfo:
            "曾帮助学员口播账号半年涨粉320w，最高播放量达4000w，月引流3万人进入私域变现，月利润高达300w，擅长口播类，种草类账号的运营。",
        },
        {
          name: "抖音分析师作者",
          teachInfo:
            "曾帮助过3000+短视频账号分析内容优化，通过8小时粉丝裂变，微信涨粉20倍。利用自创方法在搜索引擎霸屏每月为企业带来50万IP流量，月销售额提升50%以上。",
          performanceInfo:
            "擅长技术手段拉动运营数据，挖掘平台漏洞，曾利用搜索引擎bug，日引流1w+意向用户到企业网站，自主研发抖音分析师、微信裂变工具。",
        },
        {
          name: "零度老师",
          teachInfo:
            "红粉笔联合创始人，曾在中山大学、河北经贸大学等二十余所高校讲授短视频、电商实训项目。具有多个领域商业变现经验，涵盖教育、娱乐、剧情、旅行、电商种草等领域。",
          performanceInfo:
            "指导众多学员项目案例，学员零启动美食账号单个作品涨粉20w+、零启动新奇特特效账号首作品流量破100w+。",
        },
        
      ],
    };
  },
  methods: {
    changeCur(index) {
      this.show = true;
      this.cur = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box10 {
  padding: 80px 0 58px;

  width: 100%;
  background: #fef1ec url("../../../assets/coursePage/newMedia/box8/bgc.png")
    no-repeat;
  background-size: cover;
  background-position: top center;
  .subTitle {
    background: url("../../../assets/coursePage/newMedia/box8/subtitle.png");
    width: 728px;
    background-size: cover;
    height: 112px;
    margin: 48px auto 0px;
    padding: 19px 217px 0 215px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    p {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 32px;
    }
  }
  .teacher-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px auto 0;
    padding: 0 30px;
    .teacher:last-child {
      border-radius: 20px;
    }
    .teacher {
      margin-bottom: 30px;
      padding-left: 16px;
      width: 330px;
      height: 415px;
      background-size: contain;
      background-repeat: no-repeat;
      box-sizing: border-box;
      color: #fff;
      padding-right: 28px;

      .tName {
        margin-top: 278px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 40px;
        text-shadow: 0px 4px 10px #e45e44;
      }
      p {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 38px;
        text-shadow: 0px 4px 10px #d96e55;
      }
    }
    .teacher:last-child {
      margin-bottom: 0;
    }
  }

  .pop {
    padding: 40px 46px;
    padding-bottom: 64px;

    box-sizing: border-box;
    .pop-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      .title {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
      }
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }

    p {
      position: relative;
      // display: flex;
      margin-bottom: 16px;

      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
    .tag {
      margin-top: 28px;
      padding: 10px 15px;
      width: max-content;
      background-color: #ffe6e1;
      border-radius: 6px;
      font-family: PingFang-SC-Medium;
      font-size: 24px;
      text-align: center;
      line-height: 30px;
      color: #ff6a4d;
      margin-bottom: 20px;
    }
  }
}
</style>
